<script setup>
import { computed } from 'vue'

const props = defineProps({
    checked: {
        type: [Array, Boolean],
        default: false,
    },
    value: {
        type: [String, Number, Boolean],
        default: null,
    },
})

const emit = defineEmits(['update:checked'])

const proxyChecked = computed({
    get: () => props.checked,
    set: (val) => emit('update:checked', val),
})
</script>

<template>
    <input
        class="bg-surface-container-low text-primary-container focus:ring-primary-container/40 h-5 w-5 rounded border-zinc-700 focus:ring-2 focus:ring-offset-0 focus:outline-none"
        v-model="proxyChecked"
        :value="value"
        type="checkbox"
    />
</template>
